<template>
    <view-section-card title="기본정보">
        <v-card-text>
            <v-row class="ma-n2">
                <v-col cols="12" md="6" class="pa-2">
                    <v-select v-model="form.code" label="벤더" :items="codes" v-bind="attrs_input" @input="emit" />
                </v-col>
                <v-col cols="12" md="6" class="pa-2">
                    <v-text-field v-model="form.name" label="이름" v-bind="attrs_input" @input="emit" />
                </v-col>
                <v-col cols="12" class="pa-2">
                    <v-text-field v-model="form.site" label="웹사이트" v-bind="attrs_input" @input="emit" />
                </v-col>
                <v-col cols="12" md="6" class="pa-2">
                    <v-text-field v-model="form.nation" label="국가" v-bind="attrs_input" @input="emit" />
                </v-col>
                <v-col cols="12" md="6" class="pa-2">
                    <v-select v-model="form.currency" label="화폐단위" :items="currencies" v-bind="attrs_input" @input="emit" />
                </v-col>
                <v-col>
                    <v-text-field v-model="form.color" label="그래프 색상" v-bind="attrs_input" @input="emit">
                        <template #prepend>
                            <v-avatar :color="form.color" size="32" class="mt-n1 elevation-2" />
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
        </v-card-text>
    </view-section-card>
</template>

<script>
import { attrs_input } from "@/assets/variables/attrs";
import { initManufacturingVendor } from "@/assets/variables/inits";
import { MANUFACTURING_VENDOR_CODES, MANUFACTURING_VENDOR_CURRENCIES } from "@/assets/variables/constants";

import ViewSectionCard from "@/components/console/dumb/view/view-section-card.vue";

const codes = Object.values(MANUFACTURING_VENDOR_CODES);
const currencies = Object.values(MANUFACTURING_VENDOR_CURRENCIES);

export default {
    components: {
        ViewSectionCard,
    },
    props: {
        value: { type: Object, default: initManufacturingVendor },
    },
    data: () => ({
        form: initManufacturingVendor(),

        codes,
        currencies,
        attrs_input,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initManufacturingVendor(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>
